/**
 * Client Portal Components
 * 
 * Complete client portal UI system for authenticated customers.
 * Implements the design from the frontend team's example.
 * 
 * @example
 * ```tsx
 * import { PortalLayout, Dashboard } from '@/components/client-portal';
 * 
 * export default function AccountPage() {
 *   return (
 *     <PortalLayout>
 *       <Dashboard />
 *     </PortalLayout>
 *   );
 * }
 * ```
 */

// Layout Components
export { PortalLayout } from './PortalLayout';
export { PortalLayoutClient } from './PortalLayoutClient';
export { Sidebar } from './Sidebar';
export type { PortalView } from './Sidebar';

// UI Components
export { Card } from './ui/Card';
export { Button } from './ui/Button';
export { Badge } from './ui/Badge';
export { AnimatedCounter } from './ui/AnimatedCounter';

// Dashboard Components
export { ConciergeWidget } from './dashboard/ConciergeWidget';

// View Components
export { Dashboard } from './views/Dashboard';
export { SavedProperties } from './views/SavedProperties';
export { SpacesView } from './views/SpacesView';
export { MyOffers } from './views/MyOffers';
export { Enquiries } from './views/Enquiries';
export { Bookings } from './views/Bookings';
export { Profile } from './views/Profile';
export { MyProposals } from './views/MyProposals';
export { MyDeals } from './views/MyDeals';
export { MyFeedback } from './views/MyFeedback';
export { MySavedSearches } from './views/MySavedSearches';

// Commerce Portal Views
export { OrderHistory } from './views/OrderHistory';
export { OrderDetailView } from './views/OrderDetail';
